import {
  BULK_FETCH_BY_TEMPLATE_IDS__ERROR,
  BULK_FETCH_BY_TEMPLATE_IDS__REQUEST,
  BULK_FETCH_BY_TEMPLATE_IDS__SUCCESS,
  FETCH_ALL__ERROR,
  FETCH_ALL__REQUEST,
  FETCH_ALL__SUCCESS,
  FETCH_BY_TEMPLATE_ID__ERROR,
  FETCH_BY_TEMPLATE_ID__REQUEST,
  FETCH_BY_TEMPLATE_ID__SUCCESS,
  FETCH_VISIBLE_OVERVIEW__ERROR,
  FETCH_VISIBLE_OVERVIEW__REQUEST,
  FETCH_VISIBLE_OVERVIEW__SUCCESS,
  SET_VISIBLE_OVERVIEW_TEMPLATES,
  UPDATE_TEMPLATES_ORDER,
} from "./actionTypes";
import {
  ErrorFetchAllTemplatesMetadata,
  ErrorFetchTemplateMetadata,
  ErrorFetchTemplateMetadataBulk,
  ErrorFetchVisibleOverviewTemplatesMetadata,
  RequestFetchAllTemplatesMetadata,
  RequestFetchTemplateMetadata,
  RequestFetchTemplateMetadataBulk,
  RequestFetchVisibleOverviewTemplatesMetadata,
  SetVisibleOverviewTemplatesIds,
  SuccessFetchAllTemplatesMetadata,
  SuccessFetchTemplateMetadata,
  SuccessFetchTemplateMetadataBulk,
  SuccessFetchVisibleOverviewTemplatesMetadata,
  TemplateMetadataDISPATCH,
  UpdateTemplatesOrder,
} from "./types";
import { TemplateId } from "../../globalTypes";

import { AError } from "../../requests/types";
/* ********** FETCH ALL TEMPLATES METADATA ********** */
export const requestFetchAllTemplatesMetadata =
  (): RequestFetchAllTemplatesMetadata => ({
    type: FETCH_ALL__REQUEST,
  });

export const successFetchAllTemplatesMetadata = (
  allTemplatesMetadata: TemplateMetadataDISPATCH[]
): SuccessFetchAllTemplatesMetadata => ({
  type: FETCH_ALL__SUCCESS,
  payload: allTemplatesMetadata,
});

export const errorFetchAllTemplatesMetadata = (
  error: AError
): ErrorFetchAllTemplatesMetadata => ({
  type: FETCH_ALL__ERROR,
  error,
});
/* ********** FETCH ALL TEMPLATES METADATA ********** */

export const requestFetchVisibleOverviewTemplatesMetadata =
  (): RequestFetchVisibleOverviewTemplatesMetadata => ({
    type: FETCH_VISIBLE_OVERVIEW__REQUEST,
  });

export const successFetchVisibleOverviewTemplatesMetadata = (
  visibleOverviewTemplatesMetadata: TemplateMetadataDISPATCH[]
): SuccessFetchVisibleOverviewTemplatesMetadata => ({
  type: FETCH_VISIBLE_OVERVIEW__SUCCESS,
  payload: visibleOverviewTemplatesMetadata,
});

export const errorFetchVisibleOverviewTemplatesMetadata = (
  error: AError
): ErrorFetchVisibleOverviewTemplatesMetadata => ({
  type: FETCH_VISIBLE_OVERVIEW__ERROR,
  error,
});

/* ********** FETCH TEMPLATE METADATA ********** */
export const requestFetchTemplateMetadata = (
  templateId: TemplateId
): RequestFetchTemplateMetadata => ({
  type: FETCH_BY_TEMPLATE_ID__REQUEST,
  payload: { id: templateId },
});

export const successFetchTemplateMetadata = (
  metadata: TemplateMetadataDISPATCH
): SuccessFetchTemplateMetadata => ({
  type: FETCH_BY_TEMPLATE_ID__SUCCESS,
  payload: metadata,
});

export const errorFetchTemplateMetadata = (
  templateId: TemplateId,
  error: AError
): ErrorFetchTemplateMetadata => ({
  type: FETCH_BY_TEMPLATE_ID__ERROR,
  payload: { id: templateId },
  error,
});

/* ********** FETCH TEMPLATE METADATA BULK ********** */
export const requestFetchTemplateMetadataBulk = (
  templateIds: TemplateId[]
): RequestFetchTemplateMetadataBulk => ({
  type: BULK_FETCH_BY_TEMPLATE_IDS__REQUEST,
  payload: { ids: templateIds },
});

export const successFetchTemplateMetadataBulk = (
  metadata: TemplateMetadataDISPATCH[]
): SuccessFetchTemplateMetadataBulk => ({
  type: BULK_FETCH_BY_TEMPLATE_IDS__SUCCESS,
  payload: metadata,
});

export const errorFetchTemplateMetadataBulk = (
  templateIds: TemplateId[],
  error: AError
): ErrorFetchTemplateMetadataBulk => ({
  type: BULK_FETCH_BY_TEMPLATE_IDS__ERROR,
  payload: { ids: templateIds },
  error,
});

export const setVisibleOverviewTemplateIds = (
  templateIds: TemplateId[]
): SetVisibleOverviewTemplatesIds => ({
  type: SET_VISIBLE_OVERVIEW_TEMPLATES,
  payload: { ids: templateIds },
});

export const updateTemplatesOrder = (
  templatesOrder: Record<number, number>
): UpdateTemplatesOrder => ({
  type: UPDATE_TEMPLATES_ORDER,
  payload: { templatesOrder },
});

export {
  fetchAllTemplatesMetadata,
  fetchTemplateMetadataForTemplateId,
  fetchVisibleOverviewTemplatesMetadata,
  fetchTemplateMetadataForTemplateChildren,
  fetchTemplateMetadataForTemplateIds,
} from "./thunks";
